import React from 'react';
import EulaDoc from '../../Components/EulaDoc';

export const Eula = () => {
  return (
    <EulaDoc />
  )
}

export default Eula;